import axios from 'axios';
import { TSignedUrl } from 'types';
import { TEXT_STRING } from '../constants';

// Authorization: Bearer <ucode> は configs/axios.ts のインターセプタが自動付与する
const getMaleChatSignedUrl = async (body: {
  contentType: string;
  size: number;
}): Promise<TSignedUrl> => {
  const response = await axios.post<TSignedUrl>('upload/male/signed-url', body);
  return response.data;
};

/**
 * チャット添付（動画/PDF）を S3 にアップロードする。
 * 署名URL発行 → PUT まで行い、公開URL付きの署名情報を返す。
 * 失敗時は UPLOAD_FAILED を throw（サーバ由来のエラーは axios がそのまま伝える）。
 */
const uploadChatFileToS3 = async (file: File): Promise<TSignedUrl> => {
  const signed = await getMaleChatSignedUrl({
    contentType: file.type,
    size: file.size,
  });

  // fetch はFile.typeをContent-Typeへ自動設定する。現presignerでは署名対象外だが、
  // S3へ正しいmetadataを保存するためブラウザの自動設定を利用する。
  const response = await fetch(signed.preSignedUrl, {
    method: 'PUT',
    body: file,
  });

  if (!response.ok || !signed.uploadedUrl) {
    throw new Error(TEXT_STRING.ERROR.UPLOAD_FAILED);
  }

  return signed;
};

export { getMaleChatSignedUrl, uploadChatFileToS3 };
